import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LoadingScreen } from "@/components/ProtectedRoute";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const role = localStorage.getItem("ll_pending_role") || "customer";
    const referral = localStorage.getItem("ll_pending_ref") || null;
    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId, role, referral_code: referral });
        if (res.data.token) localStorage.setItem("ll_token", res.data.token);
        setUser(res.data.user);
        localStorage.removeItem("ll_pending_role");
        localStorage.removeItem("ll_pending_ref");
        window.history.replaceState({}, "", "/");
        const u = res.data.user;
        navigate(u.role === "admin" ? "/admin" : u.role === "provider" ? "/provider" : "/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return <LoadingScreen />;
}
